<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">清风论坛></span>
        <span @click="GoreportEvaluation">亦廉课堂></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>李克强同德国总理举行视频会晤</h1>
        <h2><span class="mg-16">来源：新华社</span>|<span class="mg-16">发布时间：2020-03-30&nbsp;13:30</span></h2>
        <h3>据中央广播电视总台中国之声《新闻和报纸摘要》报道，国务院总理李克强11日在人民大会堂同德国总理默克尔举行视频会晤。</h3>
        <h3>李克强表示，新冠肺炎疫情对中德交往与合作造成冲击，但双方合作没有停步，将继续向前发展。中方高度重视中德关系，前不久习近平主席同你通了电话。中方愿在相互尊重、平等互利基础上同德方深化互信，保持对话，推进各领域合作，推动中德关系取得新进展。</h3>
        <div class="PIC-BOX">
          <img :src="PicBannertest1" alt />
        </div>
        <h3>李克强应询介绍了中国疫情防控工作，表示愿同德方深化抗疫交流合作。</h3>
        <h3>李克强指出，疫情过后要实现经济恢复发展，中德应当共同维护多边主义，促进贸易投资自由化便利化。中国正在进一步扩大开放，愿为各国企业来华投资提供良好营商环境。中德要扩大双向开放，用好已开通的人员往来“快捷通道”，为企业合作和复工复产提供便利，共同维护产业链供应链安全稳定。</h3>
        <h3>李克强表示，中国一贯支持欧洲一体化进程，乐见欧盟保持团结和繁荣。中德、中欧加强开放合作不是权宜之计，而是符合彼此共同利益，可以实现互利双赢多赢。今年下半年德国将担任欧盟轮值主席国，期待德方为促进中欧关系发展发挥积极作用。我们愿同欧方保持高层交往，推进务实合作，争取早日完成中欧投资协定谈判，更好实现共同发展。</h3>
        <div class="PIC-BOX">
          <img :src="PicBannertest2" alt />
        </div>
        <h3>默克尔表示，德中高层沟通密切，在抗击疫情方面开展了良好合作。德方欢迎中国坚持扩大对外开放，将继续促进德中各领域合作。德中都主张加强多边主义，愿密切在世界贸易组织事务中的沟通协调。德方愿同中方筹备好欧中高层交往，加快欧中投资协定谈判，推动德中、欧中关系取得更大发展。</h3>
        <h3>会晤前，双方举行了汽车、重型燃气轮机试验电站、人员培训等双边合作文件“云签约”仪式。</h3>
        <h3>王毅、何立峰等出席会晤。</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      PicBannertest1: require("../../../../assets/image/bannertest1.jpg"),
      PicBannertest2: require("../../../../assets/image/bannertest2.jpg")
    };
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/forum");
    },
    GoreportEvaluation() {
      this.$router.push({ name: "forumClassroom" });
    }
  }
};
</script>

<style lang="less" scoped>

.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
  margin-bottom: 30px;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
img{
  margin: 20px 0px;
}
.mg-16{
  margin: 0px 16px;
}
</style>